export default function StatCard({ label, value, subtitle, accentColor = 'text-on-surface', icon }) {
  return (
    <div className="bg-surface-container p-5 rounded-xl relative overflow-hidden border border-outline-variant/30 hover:border-outline-variant/40 transition-colors duration-200">
      {icon && (
        <div className="absolute -right-3 -top-3 opacity-[0.05]">
          <span className="material-symbols-outlined text-7xl">{icon}</span>
        </div>
      )}
      <p className="font-label text-[11px] uppercase tracking-[0.12em] text-on-surface-variant font-semibold mb-1">{label}</p>
      <h3 className={`font-expanded text-4xl font-headline font-bold leading-none tracking-tight tabular-nums ${accentColor}`}>{value}</h3>
      {subtitle && (
        <p className="mt-2 text-xs text-on-surface-variant">{subtitle}</p>
      )}
    </div>
  );
}
